export default function() {
    return {
        surveys: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        searchParams: {
        },
        detailedSurvey: {
            id: null
        },
        showDetailedSurvey: false,
        search: {},
        fields: [
            {
                key: 'trip',
                label: 'Trip'
            },
            {
                key: 'answered',
                label: 'Respondido pela agência'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
